export enum RedirectType {
  Cloudflare = 'cloudflare',
  Cookie = 'cookie',
}

export const stateSwitchQueryParam = 'ts'
export const stateSwitchRedirectResultQueryParam = 'r_result'
export const stateSwitchRedirectTypeQueryParam = 'r_type'
export const REDIRECT_COOKIE_KEY = 'wwwRedirect'

export type TheHeaderVariant = 'full' | 'logo-only' | false
